import styled from 'styled-components';

export const Section = styled.section`
  padding: 104px 24px;
  background: ${({ tone }) =>
    tone === 'subtle' ? 'var(--bg-subtle)' : 'var(--bg)'};

  @media screen and (max-width: 600px) {
    padding: 72px 20px;
  }
`;

export const SectionInner = styled.div`
  max-width: var(--maxw);
  margin: 0 auto;
`;

export const SectionHeader = styled.div`
  max-width: 660px;
  margin: 0 auto 56px auto;
  text-align: center;
`;

export const Eyebrow = styled.span`
  display: inline-block;
  color: var(--accent-strong);
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  margin-bottom: 14px;
`;

export const SectionTitle = styled.h2`
  font-size: 2.6rem;
  font-weight: 800;
  color: var(--ink);

  @media screen and (max-width: 480px) {
    font-size: 2rem;
  }
`;

export const SectionLead = styled.p`
  margin-top: 16px;
  font-size: 1.12rem;
  color: var(--text);
  line-height: 1.65;
`;
